import React, {useEffect, useRef} from 'react'
import { gsap } from "gsap";
import styled from 'styled-components'
import { MDBContainer, MDBRow, MDBCol, MDBBtn } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom'
import heroImg from '../assets/hero-mental-health.svg'

const Hero = () => {

  const titlesRef = useRef();
  const mainImageRef = useRef();
  
  //:::: greensock animation
  // wait until DOM has been rendered
  useEffect(() => {
    //gsap.fromTo(titlesRef.current, { opacity: 0}, { opacity: 1, duration: 5}) 
    gsap.fromTo(titlesRef.current, { opacity: 0, marginLeft: "-500px"}, {opacity: 1, marginLeft: 0, duration: 2, ease: 'expo.inOut'});
    gsap.fromTo(mainImageRef.current, { opacity: 0, x: "2500px"}, {opacity: 1, x: 0, duration: 1.5, delay:1, ease: 'expo.inOut'});
  });
  return (
    <Wrapper className="section-center">
        <MDBContainer fluid>
            <MDBRow className="d-flex justify-content-between">
                <MDBCol sm='12' md="5" className="d-flex flex-column align-items-start justify-content-center" ref={titlesRef}>
                    <div className="d-flex align-items-left flex-column px-5 titles-container">
                        <h3 className="text-start text-white display-4 hero-mainTitle">PSICÓLOGA CLÍNICA e <span>PSICOTERAPEUTA PSICANALÍTICA</span> em especialização</h3>
                        <h5 className="mb-5 text-light text-start">Consultas em português, francês, espanhol e inglês</h5>
                    </div>
                    <Link to="/sobre" className="px-5"> 
                        <MDBBtn rounded className="main-btn px-5 py-3 ">saiba mais</MDBBtn>
                    </Link>
                </MDBCol>
                <MDBCol sm='12' md="7" className="mb-0 pb-0 pe-0">
                    <img src={heroImg} alt="mental health" className="hero-img img-fluid" ref={mainImageRef}/>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    </Wrapper>
  )
}
const Wrapper = styled.section`
    margin-top:6rem;
    display: grid;
    place-items: center;

    .hero-mainTitle {
        font-weight: 500;
    }

    span {
        color: var(--website-secondary-color);
    }
    @media (max-width: 985px) {

        margin-top:8rem;
        h3 {
            text-align: center;
            font-size: 2.2rem;
        }
        h5 {
            text-align: center;
        }
    }

    @media (max-width: 400px) {
        .titles-container {
        }
    }

`
export default Hero
